<template>
	<div>
		<v-card :loading="identificacionesDePaís.listando">

			<v-card-title class="headline">Persona</v-card-title>

			<v-card-text>

				<v-radio-group v-model="datos_.tipo">
					<template v-slot:label>
						<div>Tipo de persona:</div>
					</template>
					<v-radio value="natural" class="mt-3">
						<template v-slot:label>
							<div>
								<v-icon :class="{'primary--text': datos_.tipo === 'natural'}">mdi-account</v-icon>
								&nbsp;
								<strong :class="{'primary--text': datos_.tipo === 'natural'}">Natural</strong>
							</div>
						</template>
					</v-radio>
					<v-radio value="jurídica">
						<template v-slot:label>
							<div>
								<v-icon :class="{'primary--text': datos_.tipo === 'jurídica'}">mdi-domain</v-icon>
								&nbsp;
								<strong :class="{'primary--text': datos_.tipo === 'jurídica'}">Jurídica</strong>
							</div>
						</template>
					</v-radio>
				</v-radio-group>

				<v-row>
					<v-col cols="6" sm="4">
						<v-select
							v-model="datos_._identificaciónDePaís_tipo"
							:items="identificacionesDePaís.listado"
							prepend-icon="mdi-id-card"
							item-text="descripción.formal"
							item-value="identificador"
							label="Tipo de identificación"
						></v-select>
					</v-col>
					<v-col cols="6" sm="8">
						<v-text-field
							v-model="datos_._identificaciónDePaís_valor"
							maxlength="30"
							label="Número de identificación"
						></v-text-field>
					</v-col>
				</v-row>

				<div v-if="datos_.tipo === 'natural'">

					<v-text-field
						v-model="datos_.natural.nombres"
						maxlength="100"
						label="Nombres sin apellidos"
						required
					></v-text-field>

					<v-text-field
						v-model="datos_.natural.apellidos"
						maxlength="100"
						label="Apellidos (opcional)"
					></v-text-field>

					<v-text-field
						v-model="datos_.natural._sitioWeb"
						prepend-icon="mdi-web"
						maxlength="200"
						label="Sitio web (opcional)"
						type="url"
					></v-text-field>

					<v-text-field
						v-model="datos_.natural._correoElectrónico"
						prepend-icon="mdi-email"
						maxlength="100"
						label="Correo electrónico (opcional)"
						type="email"
					></v-text-field>

					<v-text-field
						v-model="datos_.natural._númeroTelefónico"
						prepend-icon="mdi-cellphone"
						maxlength="20"
						label="Número telefónico (opcional)"
						type="tel"
					></v-text-field>

					<v-text-field
						v-model="datos_.natural._direcciónPostal"
						prepend-icon="mdi-map-marker"
						maxlength="100"
						label="Dirección postal (opcional)"
					></v-text-field>

				</div>

				<div v-if="datos_.tipo === 'jurídica'">

					<v-text-field
						v-model="datos_.jurídica.nombreLegal"
						maxlength="100"
						label="Nombre legal"
						required
					></v-text-field>

					<v-text-field
						v-model="datos_.jurídica.nombreComercial"
						maxlength="100"
						label="Nombre comercial (opcional)"
					></v-text-field>

					<v-text-field
						v-model="datos_.jurídica._sitioWeb"
						prepend-icon="mdi-web"
						maxlength="100"
						label="Sitio web (opcional)"
						type="url"
					></v-text-field>

					<v-text-field
						v-model="datos_.jurídica._direcciónPostal"
						prepend-icon="mdi-map-marker"
						maxlength="100"
						label="Dirección postal (opcional)"
					></v-text-field>

					<v-text-field
						v-model="datos_.jurídica._contacto_nombre"
						prepend-icon="mdi-account"
						maxlength="100"
						label="Nombre del contacto (opcional)"
					></v-text-field>

					<v-text-field
						v-model="datos_.jurídica._contacto_númeroTelefónico"
						prepend-icon="mdi-phone"
						maxlength="100"
						label="Número telefónico del contacto (opcional)"
						type="tel"
					></v-text-field>

					<v-text-field
						v-model="datos_.jurídica._contacto_correoElectrónico"
						prepend-icon="mdi-email"
						maxlength="100"
						label="Correo electrónico del contacto (opcional)"
						type="email"
					></v-text-field>

				</div>

				<v-switch
					v-model="datos_.habilitada"
					:label="datos_.habilitada ? 'Habilitada' : 'Inhabilitada'"
					class="my-6"
					color="success"
				></v-switch>

			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					color="grey darken-1"
					text
					:disabled="fuente.guardando"
					@click="cancelar"
				>
					Cancelar
				</v-btn>

				<v-btn
					color="green darken-1"
					text
					:loading="fuente.guardando"
					@click="guardar"
				>
					Guardar
				</v-btn>
			</v-card-actions>

		</v-card>
	</div>
</template>

<script>
import { personas, identificacionesDePaís } from '@/../../cliente_comun/fuentes'

export default {
	name: 'persona',
	data: () => ({
		fuente: personas,
		identificacionesDePaís: identificacionesDePaís,
		datos_: {
			identificador: '',
			habilitada: true,
			tipo: '',
			_identificaciónDePaís_tipo: '',
			_identificaciónDePaís_valor: '',
			natural: {
				nombres: '',
				apellidos: '',
				_sitioWeb: '',
				_correoElectrónico: '',
				_númeroTelefónico: '',
				_direcciónPostal: '',
			},
			jurídica: {
				nombreLegal: '',
				nombreComercial: '',
				_sitioWeb: '',
				_direcciónPostal: '',
				_contacto_nombre: '',
				_contacto_númeroTelefónico: '',
				_contacto_correoElectrónico: '',
			}
		}
	}),
	props: ['datos'],
	watch: {
		datos: {
			handler: function(d) {
				this.limpiar()

				if (!d) {
					return
				}

				let iden = { tipo: '', valor: '' }
				iden.tipo = d[d.tipo] && d[d.tipo].identificaciones && d[d.tipo].identificaciones.locales ? d[d.tipo].identificaciones.locales[0].tipo.identificador : ''
				iden.valor = d[d.tipo] && d[d.tipo].identificaciones && d[d.tipo].identificaciones.locales ? d[d.tipo].identificaciones.locales[0].valor : ''

				this.datos_.identificador = d.identificador || ''
				this.datos_.habilitada = d.habilitada || false
				this.datos_.tipo = d.tipo || ''
				this.datos_._identificaciónDePaís_tipo = iden.tipo
				this.datos_._identificaciónDePaís_valor = iden.valor
				this.datos_.natural.nombres = d.natural && d.natural.nombres ? d.natural.nombres : ''
				this.datos_.natural.apellidos = d.natural && d.natural.apellidos ? d.natural.apellidos : ''
				this.datos_.natural._sitioWeb = d.natural && d.natural.sitiosWeb && d.natural.sitiosWeb.length ? d.natural.sitiosWeb[0] : ''
				this.datos_.natural._correoElectrónico = d.natural && d.natural.correosElectrónicos && d.natural.correosElectrónicos.length ? d.natural.correosElectrónicos[0] : ''
				this.datos_.natural._númeroTelefónico = d.natural && d.natural.númerosTelefónicos && d.natural.númerosTelefónicos.length ? d.natural.númerosTelefónicos[0] : ''
				this.datos_.natural._direcciónPostal = d.natural && d.natural.direccionesPostales && d.natural.direccionesPostales.length ? d.natural.direccionesPostales[0].dirección : ''
				this.datos_.jurídica.nombreLegal = d.jurídica && d.jurídica.nombreLegal ? d.jurídica.nombreLegal : ''
				this.datos_.jurídica.nombreComercial = d.jurídica && d.jurídica.nombreComercial ? d.jurídica.nombreComercial : ''
				this.datos_.jurídica._sitioWeb = d.jurídica && d.jurídica.sitiosWeb && d.jurídica.sitiosWeb.length ? d.jurídica.sitiosWeb[0].dirección : ''
				this.datos_.jurídica._direcciónPostal = d.jurídica && d.jurídica.direccionesPostales && d.jurídica.direccionesPostales.length ? d.jurídica.direccionesPostales[0].dirección : ''
				this.datos_.jurídica._contacto_nombre = d.jurídica && d.jurídica.contactos && d.jurídica.contactos[0] ? d.jurídica.contactos[0].nombre || '' : ''
				this.datos_.jurídica._contacto_númeroTelefónico = d.jurídica && d.jurídica.contactos ? d.jurídica.contactos[0].númeroTelefónico || '' : ''
				this.datos_.jurídica._contacto_correoElectrónico = d.jurídica && d.jurídica.contactos ? d.jurídica.contactos[0].correoElectrónico || '' : ''
			},
			deep: true
		}
	},
	mounted: function() {
		this.identificacionesDePaís.inicializar()
	},
	methods: {
		guardar: function() {
			let identificaciones = {
				locales: [{
					tipo: { identificador: this.datos_._identificaciónDePaís_tipo },
					valor: this.datos_._identificaciónDePaís_valor
				}]
			}

			let datos = JSON.parse(JSON.stringify(this.datos_))
			datos.natural.sitiosWeb = [this.datos_.natural._sitioWeb]
			datos.natural.correosElectrónicos = [this.datos_.natural._correoElectrónico]
			datos.natural.númerosTelefónicos = [this.datos_.natural._númeroTelefónico]
			datos.natural.direccionesPostales = [{dirección: this.datos_.natural._direcciónPostal}]
			datos.natural.identificaciones = identificaciones
			datos.jurídica.sitiosWeb = [{dirección: this.datos_.jurídica._sitioWeb}]
			datos.jurídica.direccionesPostales = [{dirección: this.datos_.jurídica._direcciónPostal}]
			datos.jurídica.contactos = [{
				nombre: this.datos_.jurídica._contacto_nombre,
				númeroTelefónico: this.datos_.jurídica._contacto_númeroTelefónico,
				correoElectrónico: this.datos_.jurídica._contacto_correoElectrónico,
			}]
			datos.jurídica.identificaciones = identificaciones

			this.fuente.guardar(datos, this.datos_.identificador).then( () => {
				this.limpiar()
				this.$emit('guardar', true)
			})
		},
		cancelar: function() {
			this.limpiar()
			this.$emit('cancelar', true)
		},
		limpiar: function() {
			this.datos_.identificador = ''
			this.datos_.habilitada = true
			this.datos_.tipo = ''
			this.datos_._identificaciónDePaís_tipo = ''
			this.datos_._identificaciónDePaís_valor = ''
			this.datos_.natural.nombres = ''
			this.datos_.natural.apellidos = ''
			this.datos_.natural._sitioWeb = ''
			this.datos_.natural._correoElectrónico = ''
			this.datos_.natural._númeroTelefónico = ''
			this.datos_.natural._direcciónPostal = ''
			this.datos_.jurídica.nombreLegal = ''
			this.datos_.jurídica.nombreComercial = ''
			this.datos_.jurídica._sitioWeb = ''
			this.datos_.jurídica._direcciónPostal = ''
			this.datos_.jurídica._contacto_nombre = ''
			this.datos_.jurídica._contacto_númeroTelefónico = ''
			this.datos_.jurídica._contacto_correoElectrónico = ''
		},
	}
}

</script>